import { createContext } from 'react';
export var MsgContext = /*#__PURE__*/createContext({
  refresh: 0,
  token: '',
  env: 'dev',
  count: {
    read: 0,
    unread: 0
  },
  _setCount: function _setCount() {}
});